import liff from '@line/liff'
import LineInfo from '@/interfaces/line-info'
import { store } from '@/store'

export const isTokenExpired = (): boolean => {
  const token = liff.getDecodedIDToken()

  if (token) {
    try {
      const expiredToken: any = token.exp

      return new Date(expiredToken * 1000) < new Date()
    } catch (e) {
      return true
    }
  }
  return true
}

export const validateToken = async () => {
  if (isTokenExpired()) {
    await lineLogin()
    return false
  }
  return true
}

export const getProfile = async (): Promise<any> => {
  const profile = await liff.getProfile()
  const result: any = {
    displayName: '',
    pictureUrl: '',
    statusMessage: '',
    userId: '',
  }

  result.displayName = profile.displayName
  result.pictureUrl = profile.pictureUrl
  result.statusMessage = profile.statusMessage
  result.userId = profile.userId

  return result
}

export const lineLogin = async () => {
  try {
    if (!liff.isLoggedIn() || isTokenExpired()) {
      liff.logout()
      const currentUrl = new URL(window.location.href)
      const queryString = currentUrl.search
      const redirectUri = `${currentUrl.origin}${currentUrl.pathname}${queryString}`
      liff.login({ redirectUri })
    } else {
      const profile = await getProfile()
      const result: LineInfo = {
        idToken: '',
        profile: {
          displayName: '',
          pictureUrl: '',
          statusMessage: '',
          userId: '',
        },
        socialToken: '',
      }
  
      result.idToken = liff.getIDToken()
      result.socialToken = liff.getAccessToken()
      result.profile = profile
  
      return result
    }
  } catch (error) {
    store.dispatch('connectivity/checkOnlineStatus')
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
